export const DEFAULT_TIMEOUT_MS = 30000;
export const UPLOAD_TIMEOUT_MS = 120000;
export const NETWORK_ERROR_MESSAGE = 'Нет связи с сервером. Проверьте интернет и повторите попытку.';
export const TIMEOUT_ERROR_MESSAGE = 'Сервер не ответил вовремя. Проверьте интернет и повторите попытку.';

export const createNetworkError = (message = NETWORK_ERROR_MESSAGE) => {
    const error = new Error(message);
    error.isNetworkError = true;
    return error;
};

/**
 * fetch с таймаутом и русскими сообщениями вместо "Load failed" / "Failed to fetch".
 * Таймер не снимается после получения заголовков: он же ограничивает чтение тела ответа.
 */
export const fetchWithTimeout = async (url, options = {}, { timeoutMs } = {}) => {
    const isUpload = typeof FormData !== 'undefined' && options.body instanceof FormData;
    const limit = timeoutMs || (isUpload ? UPLOAD_TIMEOUT_MS : DEFAULT_TIMEOUT_MS);
    const controller = new AbortController();
    let timedOut = false;

    const timerId = setTimeout(() => {
        timedOut = true;
        controller.abort();
    }, limit);

    try {
        return await fetch(url, { ...options, signal: controller.signal });
    } catch (error) {
        clearTimeout(timerId);
        throw createNetworkError(timedOut ? TIMEOUT_ERROR_MESSAGE : NETWORK_ERROR_MESSAGE);
    }
};
